import { Link } from "react-router-dom";
import styled from "styled-components";

const LinkTo = styled(Link)`
  color: ${p => p.color && p.theme.font.color[p.color]? p.theme.font.color[p.color] : p.theme.font.color.link};
  text-decoration: "underline";
`;

export default LinkTo;
